// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"14a99907","703":"cf467336","787":"9647a2ac"}[chunkId] + ".chunk.js";
};